import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
  icon: {
    '&:hover': {
      backgroundColor: 'rgba(202, 202, 252, 0.3)',
    },
    '&:disabled': {
      '& path': {
        fill: 'rgba(44, 45, 62, 0.5)',
      },
    },
  },

  onHover: {
    '&:hover': {
      '& path': {
        fill: '#3C419A',
      },
    },
  },
}));
